import React from 'react';
import './ActivityCard.css';

export interface Activity {
  fileName: string;
  action: 'uploaded' | 'skipped' | 'error';
  reason?: string;
  activityId?: string;
  timestamp: string;
  existingActivity?: {
    activityName: string;
    activityId: string;
    startTime: string;
    distance?: number;
    duration?: number;
  };
}

interface ActivityCardProps {
  activity: Activity;
  showDetails?: boolean;
}

export const ActivityCard: React.FC<ActivityCardProps> = ({ activity, showDetails = false }) => {
  const getStatusConfig = () => {
    switch (activity.action) {
      case 'uploaded':
        return {
          icon: '✅',
          label: 'Uploaded',
          color: '#4ade80',
          bgColor: 'rgba(34, 197, 94, 0.1)',
        };
      case 'skipped':
        return {
          icon: '⏭️',
          label: 'Skipped',
          color: '#fbbf24',
          bgColor: 'rgba(251, 191, 36, 0.1)',
        };
      case 'error':
        return {
          icon: '❌',
          label: 'Error',
          color: '#f87171',
          bgColor: 'rgba(239, 68, 68, 0.1)',
        };
    }
  };

  const config = getStatusConfig();
  const timeAgo = new Date(activity.timestamp).toLocaleString();

  return (
    <div className="activity-card" style={{ borderLeftColor: config.color }}>
      <div className="activity-card__header">
        <div className="activity-card__status">
          <span className="activity-card__icon">{config.icon}</span>
          <span className="activity-card__status-label" style={{ color: config.color }}>
            {config.label}
          </span>
        </div>
        <span className="activity-card__time">{timeAgo}</span>
      </div>

      <div className="activity-card__content">
        <h4 className="activity-card__filename">{activity.fileName}</h4>
        {activity.reason && <p className="activity-card__reason">{activity.reason}</p>}
        {activity.activityId && (
          <p className="activity-card__activity-id">
            <span className="activity-card__label">Activity ID:</span>
            <code className="activity-card__code">{activity.activityId}</code>
          </p>
        )}

        {showDetails && activity.existingActivity && (
          <div className="activity-card__details" style={{ backgroundColor: config.bgColor }}>
            <div className="activity-card__details-header">
              <span className="activity-card__details-icon">🔗</span>
              <strong>Matched Activity</strong>
            </div>
            <div className="activity-card__details-content">
              <p>
                <strong>Name:</strong> {activity.existingActivity.activityName}
              </p>
              <p>
                <strong>ID:</strong> {activity.existingActivity.activityId}
              </p>
              {activity.existingActivity.distance && (
                <p>
                  <strong>Distance:</strong> {(activity.existingActivity.distance / 1000).toFixed(2)} km
                </p>
              )}
              {activity.existingActivity.duration && (
                <p>
                  <strong>Duration:</strong> {Math.floor(activity.existingActivity.duration / 60)} min
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
